import { UpdateFileRequestContent, UpdateFileResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to update file metadata
 * @param request File update parameters
 * @returns Promise with updated file details
 */
export const updateFileApi = async (request: UpdateFileRequestContent): Promise<UpdateFileResponseContent> => {
  const apiRequest = createApiRequest<UpdateFileResponseContent>('post', '/files/update');
  return apiRequest(request);
};
